import { AiseaApiFactory } from "@/api/aisea/apiFactory";
import SecureDataflowService from "@/services/secureDataflowService";

const m0checklistApi = AiseaApiFactory.get("m0checklist");

export default {

    async setSelectedRoomId({ commit }, data) {
        commit("SET_SELECTED_ROOM_ID", data)
    },

    async setChannelTimeFromState({ commit }, data) {
        commit("SET_CHANNEL_TIME_FROM", data)
    },
    async setChannelTimeToState({ commit }, data) {
        commit("SET_CHANNEL_TIME_TO", data)
    },

    async setLastChannelTimeFromState({ commit }, data) {
      commit("SET_LAST_CHANNEL_TIME_FROM", data)
    },
    async setLastChannelTimeToState({ commit }, data) {
      commit("SET_LAST_CHANNEL_TIME_TO", data)
    },

    async setSelectedVersionIdState({ commit }, data) {
        commit("SET_SELECTED_VERSION_ID", data)
    },

    async setOptionVersionIdsState({ state, commit }, params) {
      if( ! state.channelTimeFrom || ! state.channelTimeTo ) {
        return;
      }

      params.start_at = state.channelTimeFrom;
      params.end_at = state.channelTimeTo;

      const vessel = await SecureDataflowService.getVessel();
      let res = await m0checklistApi.getVersions(vessel.vessel_info.id, params);
      let version_ids = res.data.version_ids;

      commit("SET_OPTION_VERSION_IDS", version_ids)
    },

    async setTrendData({ commit, state }) {

        let params = {
          start_at:   state.channelTimeFrom,
          end_at:     state.channelTimeTo,
          version_id: state.selectedVersionId,
        };

        const vessel = await SecureDataflowService.getVessel();
        let res = await m0checklistApi.searchTrendData(vessel.vessel_info.id, params);

        // is_checked_weekly order_number でソート。
        res.data.m0_rooms.sort((a, b) => {
          let comparison = 0;
          let aCheckedWeekly = a.is_checked_weekly ? 1 : 0;
          let bCheckedWeekly = b.is_checked_weekly ? 1 : 0;
          if (aCheckedWeekly > bCheckedWeekly) {
            comparison = 1;
          } else if (aCheckedWeekly < bCheckedWeekly) {
            comparison = -1;
          } else if (a.order_number > b.order_number) {
            comparison = 1;
          } else if (a.order_number < b.order_number) {
            comparison = -1;
          }
          return comparison;
        });

        commit("SET_ROOMS", res.data);
    },
}
